import useStore from '@/hooks/useStore';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppShellSkeleton } from '@/components/common/skeletons';

const WebviewInvoice = () => {
  const { id } = useParams();
  const { authStore } = useStore();
  const { hasPermission } = authStore;
  const [loading, setLoading] = useState<boolean>(true);
  const apiUrl = import.meta.env.DEV ? '/api' : import.meta.env.VITE_API_URL;
  const canViewXeroInvoice = hasPermission(['xero_invoices_view']);

  useEffect(() => {
    const interval = setTimeout(() => {
      setLoading(false);
    }, 5000);
    return () => clearTimeout(interval);
  }, []);

  if (loading) {
    return <AppShellSkeleton variant="content" />;
  }

  return (
    <iframe
      src={
        canViewXeroInvoice
          ? `${apiUrl}/xero-invoices/${id}/summary`
          : `${apiUrl}/simple-invoices/${id}/summary`
      }
      className="h-screen w-full"
    ></iframe>
  );
};

export default WebviewInvoice;
